<p-dialog [modal]="true" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [visible]="visibility" [draggable]="false" [resizable]="false" [closable]="false" [style]="{ width: '70%', height: '50vh' }">
  <ng-template pTemplate="header">
    <div class="dialogHeader flex align-items-center justify-content-between wd-100 pl-2">
      <h4 class="font-poppin text-color-grey4">
        <span class="font-bold">{{title}}</span> ({{ legDate | dateTime }})
      </h4>
      <p-button icon="pi pi-times" (onClick)="hide()" styleClass="p-button-text p-button-rounded"></p-button>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <p-timeline [value]="getDetails()" class="update-history w-full md:w-20rem mt-3">
      <ng-template pTemplate="content" let-event>
          <div class="flex flex-row">
              <h5 class="font-bold font-poppin fw-500">{{event.title}}</h5>
          </div>
          <div class="grid mt-2 mb-4 text-sm">
              <div class="col-3">
                  <p class="fw-400 font-poppin text-color-grey4">Trip Request No</p>
                  <p class="fw-500 font-poppin text-color-black2 mt-2">
                    {{ event?.trip_no || '-' }}
                  </p>
              </div>
              <div class="col-3">
                  <p class="fw-400 font-poppin text-color-grey4">Customer Code</p>
                  <p class="fw-500 font-poppin text-color-black2 mt-2">
                    {{ event?.customer_code || '-' }}
                  </p>
              </div>
              <div class="col-3">
                  <p class="fw-400 font-poppin text-color-grey4">Invoice Reference</p>
                  <p class="fw-500 font-poppin text-color-black2 mt-2">
                    {{ event?.invoice_reference || '-' }}
                  </p>
              </div>
              <div class="col-3">
                  <p class="fw-400 font-poppin text-color-grey4">Loading Reference</p>
                  <p class="fw-500 font-poppin text-color-black2 mt-2">
                    {{ event?.loading_reference || '-' }}
                  </p>
              </div>
              <div class="col-3">
                  <p class="fw-400 font-poppin text-color-grey4">Origin</p>
                  <p class="fw-500 font-poppin text-color-black2 mt-2">
                    {{ event?.origin_address || '-' }}
                  </p>
              </div>
              <div class="col-3">
                  <p class="fw-400 font-poppin text-color-grey4">Destination</p>
                  <p class="fw-500 font-poppin text-color-black2 mt-2">
                    {{ event?.destination_name || '-' }}
                  </p>
              </div>
              <div class="col-3">
                  <p class="fw-400 font-poppin text-color-grey4">Requested Pickup Date</p>
                  <p class="fw-500 font-poppin text-color-black2 mt-2">
                    {{ event?.pickup_at | dateTime : false }}
                  </p>
              </div>
              <div class="col-3">
                  <p class="fw-400 font-poppin text-color-grey4">Requested Delivery Date</p>
                  <p class="fw-500 font-poppin text-color-black2 mt-2">
                    {{ event?.delivered_at | dateTime : false }}
                  </p>
              </div>
              <div class="col-3">
                  <p class="fw-400 font-poppin text-color-grey4">CSR (Main)</p>
                  <p class="fw-500 font-poppin text-color-black2 mt-2">
                    {{ event?.csr_main || '-' }}
                  </p>
              </div>
              <div class="col-3">
                  <p class="fw-400 font-poppin text-color-grey4">CSR (Backup)</p>
                  <p class="fw-500 font-poppin text-color-black2 mt-2">
                    {{ event?.csr_backup || '-' }}
                  </p>
              </div>
              <div class="col-3">
                  <p class="fw-400 font-poppin text-color-grey4">GMT Reference</p>
                  <p class="fw-500 font-poppin text-color-black2 mt-2">
                    {{ event?.gmt_reference || '-' }}
                  </p>
              </div>
              <div class="col-3">
                  <p class="fw-400 font-poppin text-color-grey4">Payment Reference</p>
                  <p class="fw-500 font-poppin text-color-black2 mt-2">
                    {{ event?.payment_reference || '-' }}
                  </p>
              </div>
              <div class="col-3">
                  <p class="fw-400 font-poppin text-color-grey4">Special Instructions</p>
                  <p class="fw-500 font-poppin text-color-black2 mt-2">
                    {{ event?.special_instruction || '-' }}
                  </p>
              </div>
              <div class="col-3">
                  <p class="fw-400 font-poppin text-color-grey4">Comments</p>
                  <p class="fw-500 font-poppin text-color-black2 mt-2">
                    {{ event?.comments || '-' }}
                  </p>
              </div>
              <div class="col-3">
                  <p class="fw-400 font-poppin text-color-grey4">Status</p>
                  <button pButton [attr.status]="event?.status" type="button" class="btn-status p-button-outlined">
                    {{ event?.status || '-' }}
                  </button>
              </div>
              <div class="col-3" *ngIf="event?.exception_code">
                <p class="fw-400 font-poppin text-color-grey4">Exception Code</p>
                <p class="fw-500 font-poppin text-color-black2 mt-2">
                  {{ event?.exception_code || '-' }}
                </p>
            </div>
            <div class="col-3" *ngIf="event?.exception_code">
              <p class="fw-400 font-poppin text-color-grey4">Exception Description</p>
              <p class="fw-500 font-poppin text-color-black2 mt-2">
                {{ event?.exception_description || '-' }}
              </p>
            </div>
          </div>
      </ng-template>
  </p-timeline>
  </ng-template>
</p-dialog>
